// @vue/component
export default {
  name: 'PageHeader',
  props: {
    title: {
      type: String,
      default: 'Log in',
    },
    subTitle: {
      type: String,
      default: '',
    },
    error: {
      type: String,
      default: '',
    },
    hideable: { // can be hidden by `hide-title` extra property
      type: Boolean,
      default: true,
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/widgets/PageHeader/PageHeader.js